/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Fulfillment_Waiting_On_BookingInputs */

const en_fulfillment_waiting_on_booking = /** @type {(inputs: Fulfillment_Waiting_On_BookingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Customer Service · carrier and tracking · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Customer Service · carrier and tracking · since {since}" |
*
* @param {Fulfillment_Waiting_On_BookingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_waiting_on_booking = /** @type {((inputs: Fulfillment_Waiting_On_BookingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Waiting_On_BookingInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_waiting_on_booking(inputs)
});